export const formatAmount = (amount) => {
	return amount
		? `RM ${ parseFloat(amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }`
		: 'RM 0.00';
};